<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getAgents()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Agents class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Agent</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Info</th>
                                                <th>Status</th>
                                                <th>Challenge</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in agents.data" :key="data.id" v-on:click="editAgents(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_agents" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>{{data.name}} - {{data.tier}}</div>
                                                    <div>{{data.email}}</div>
                                                </td>
                                                <th>
                                                    <label v-if="data.is_active === 'true'" class="badge badge-success"><i class="uil uil-check"></i> Active</label>
                                                    <label v-if="data.is_active === 'false'" class="badge badge-danger"><i class="uil uil-times"></i> Not Active</label>
                                                </th>
                                                <td v-on:click.stop="">
                                                    <button v-on:click="showChallenge(data)" class="btn btn-primary">{{data.challenge.length}} Challenge</button>
                                                </td>
                                                <td>{{data.created_at | formatDate}}</td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="agents.total === 0" class="text-center no-data">Agents data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="agents"
                                                :sorting="sorting"
                                                @paginate="getAgents()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Agent Data Still Empty</h2>
                                    <p>On this page you can create agent user</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Agents class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Agent</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action ca-big" v-if="del_agents.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_agents = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_agents.length}}</span> agent selected</span>
                    </div>
                    <div class="float-right">
                        <div v-b-modal.modal-Status class="btn btn-grey mr-2">
                            <i class="uil uil-sync"></i> Status
                        </div>
                        <div v-on:click.prevent="alertDeleteAgents()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_agents="del_agents" @getAgents="getAgents(),del_agents = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../agent/ModalForm.vue'
    import moment from 'moment'

    export default {
        name: "agents",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_agents:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getAgents().then(() => {
                if(this.agents.total == 0){
                    this.no_data = true
                }else{
                    this.no_data = false
                }
            })
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('AgentsControl', {
                agents: state => state.agents,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.agents.data ? this.del_agents.length == this.agents.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.agents.data.forEach(function (agents) {
                            if(agents.id !== 1){
                                selected.push(agents.id);
                            }
                        });
                    }

                    this.del_agents = selected;
                }
            }
        },
        methods: {
            ...mapActions('AgentsControl', ['getAgents','deleteAgents']),
            ...mapMutations('AgentsControl', ['CLEAR_AGENTS','ASSIGN_FORM']),
            
            editAgents:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Agents')
            },
            showChallenge:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Challenge')
            },
            alertDeleteAgents:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this agent data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteAgents(this.del_agents).then(
                            this.$toast.success('Successfully Deleting Agent'),
                            this.del_agents = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_AGENTS()
        }
    };

</script>
